import { api } from '../store/middleware/api'

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllPublicCaterers: build.query({
      query: () => `/caterer/get/all/public`,
    }),
    getSingleCaterer: build.query({
      query: (id) => `/caterer/get/single/${id}`,
    }),
    merchantSignup: build.mutation({
      query: (body) => ({
        url:"/auth/signup/caterer",
        method:"POST",
        body
      })
    })
  }),
  overrideExisting: false,
})

export const { useGetAllPublicCaterersQuery, useGetSingleCatererQuery, useMerchantSignupMutation } = extendedApi